import React from 'react';
import { EmblaOptionsType } from 'embla-carousel';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import { Box } from '@chakra-ui/react';
import WheelGesturesPlugin from 'embla-carousel-wheel-gestures';

const OPTIONS: EmblaOptionsType = {
  dragFree: true,
};

export default function Mobile({ slides }: { slides: React.ReactNode[] }) {
  const [emblaRef] = useEmblaCarousel(OPTIONS, [Autoplay({ delay: 5000, stopOnInteraction: false }), WheelGesturesPlugin()]);

  return (
    <Box
      mt={2}
      className='embla'
      style={
        {
          '--slide-size': '72%',
          '--slide-spacing': '8px',
        } as React.CSSProperties
      }
    >
      <Box
        px={4}
        className='embla__viewport'
        ref={(el: HTMLDivElement | null) => {
          emblaRef(el);
        }}
      >
        <Box className='embla__container'>
          {slides}
        </Box>
      </Box>
    </Box>
  );
}
